/** @format */

import { TTranslation, useAppTranslation } from '@/i18n/declarations';
import { useMemo } from 'react';

interface RoomFeatures {
  size: number;
  balcony: boolean;
  bathroom: boolean;
  workstation: boolean;
  wardrobe: boolean;
}

interface FlatFeatures {
  bathroomCount: number;
}

interface UseDetailsProps {
  roomFeatures: RoomFeatures;
  flatFeatures: FlatFeatures;
  flatType: string;
}

const useDetails = ({ roomFeatures, flatFeatures, flatType }: UseDetailsProps) => {
  const { size = 0, bathroom = false } = roomFeatures || {};
  const { bathroomCount } = flatFeatures;
  const { t } = useAppTranslation();

  const RoomBathroom = useMemo(() => {
    if (bathroom) return t('plp.filters.amenities.private_bathroom' as TTranslation);
    else if (bathroomCount && bathroomCount > 0) {
      if (bathroomCount === 1) {
        return t('pdp.room_features.bathroom_count' as TTranslation, { count: bathroomCount });
      } else {
        return t('pdp.room_features.bathrooms_count' as TTranslation, { count: bathroomCount });
      }
    }
  }, [bathroom, bathroomCount]);

  const roomSizeNr = size > 0 ? size.toFixed(0) : false;

  const type = useMemo(() => {
    if (flatType === 'ShareApartment') {
      return t('plp.filters.property_type.shared_property.private_bedroom' as TTranslation);
    } else if (flatType === 'StudioApartment') {
      return t('plp.filters.property_type.entire_property.studio' as TTranslation);
    } else if (flatType === 'OneBedroomApartment') {
      return t('plp.filters.property_type.entire_property.single_bedroom' as TTranslation);
    } else {
      return t('plp.filters.property_type.shared_property.private_bedroom' as TTranslation);
    }
  }, [flatType]);

  return {
    RoomBathroom,
    roomSizeNr,
    type,
  };
};

export default useDetails;
